import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import styles from './Modal.module.scss';
const Modal = t0 => {
  const $ = _c(21);
  const {
    variant: t1,
    isVisiable,
    onClose,
    children
  } = t0;
  const variant = t1 === undefined ? "responsive" : t1;
  const [isMounted, setIsMounted] = useState(isVisiable);
  const [isBottomSheet, setIsBottomSheet] = useState(variant === "bottomSheet" ? true : false);
  let t2;
  if ($[0] !== variant) {
    t2 = () => {
      if (variant === "responsive") {
        const isSmallScreen = window.innerWidth <= 767;
        setIsBottomSheet(isSmallScreen);
      }
    };
    $[0] = variant;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const updateIsBottomSheet = t2;
  let t3;
  let t4;
  if ($[2] !== isVisiable) {
    t3 = () => {
      if (isVisiable) {
        setIsMounted(true);
      } else {
        const timer = setTimeout(() => setIsMounted(false), 300);
        return () => clearTimeout(timer);
      }
    };
    t4 = [isVisiable];
    $[2] = isVisiable;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[5] !== isVisiable || $[6] !== onClose || $[7] !== updateIsBottomSheet || $[8] !== variant) {
    t5 = () => {
      if (!isVisiable) {
        return;
      }
      const handleEscapeKey = event => {
        if (event.key === "Escape") {
          onClose();
        }
      };
      document.body.style.overflowY = "hidden";
      document.addEventListener("keydown", handleEscapeKey);
      if (variant === "responsive") {
        updateIsBottomSheet();
        window.addEventListener("resize", updateIsBottomSheet);
      }
      return () => {
        document.body.style.overflowY = "auto";
        window.removeEventListener("keydown", handleEscapeKey);
        if (variant === "responsive") {
          window.removeEventListener("resize", updateIsBottomSheet);
        }
      };
    };
    t6 = [isVisiable, onClose, variant, updateIsBottomSheet];
    $[5] = isVisiable;
    $[6] = onClose;
    $[7] = updateIsBottomSheet;
    $[8] = variant;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  if (!isMounted) {
    return null;
  }
  const t7 = isVisiable ? "open" : "closed";
  let t8;
  if ($[11] !== onClose || $[12] !== t7) {
    t8 = <div className={styles.overlay} onClick={onClose} data-state={t7} />;
    $[11] = onClose;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = isBottomSheet ? styles.bottomSheetContent : `${styles.modalContent}`;
  const t10 = isVisiable ? "open" : "closed";
  let t11;
  if ($[14] !== children || $[15] !== t10 || $[16] !== t9) {
    t11 = <div role="dialog" className={t9} onClick={_temp} data-state={t10}>{children}</div>;
    $[14] = children;
    $[15] = t10;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t8) {
    t12 = <>{t8}{t11}</>;
    $[18] = t11;
    $[19] = t8;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  return t12;
};
export default Modal;
function _temp(e) {
  return e.stopPropagation();
}